import type { Editor, Range } from '@tiptap/core';
import type { SlashMenuItem, User } from '../../RichTextDescription/types';

type MentionArgs = { editor: Editor; range: Range };

export function commentMentionSearchAliases(user: User): string[] {
  const parts = [user.name, user.email, user.firstName ?? '', user.first_name ?? '', user.surname ?? ''];
  const compactName = user.name.replace(/\s+/g, '');
  return [...parts, compactName]
    .map(value => value.toLowerCase().trim())
    .filter(Boolean);
}

function matchesQuery(user: User, query: string): boolean {
  if (!query) return true;
  const q = query.toLowerCase();
  return commentMentionSearchAliases(user).some(term => term.includes(q));
}

export function buildCommentMentionItems(mentionableUsers: User[], query: string): SlashMenuItem[] {
  const q = query.trim();

  return mentionableUsers
    .filter(user => matchesQuery(user, q))
    .map(
      (user): SlashMenuItem => ({
        title: user.name,
        subtext: 'Mention',
        group: 'People',
        aliases: commentMentionSearchAliases(user),
        slashUserRow: user,
        onSelect: ({ editor, range }: MentionArgs) => {
          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertContent({
              type: 'bugherdMention',
              attrs: { id: String(user.id), label: user.name }
            })
            .insertContent(' ')
            .run();
        }
      })
    );
}
